class LiveSocketClient {
  constructor() {
    this.socket = null;
    this.handlers = {};
    this.connected = false;
    this.reconnectTimer = null;
    this.heartbeat = null;
  }

  connect(token) {
    if (!token) {
      console.warn("[LiveSocket] Missing token");
      return;
    }

    if (this.socket && this.connected) {
      return;
    }

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const host = window.location.host;
    const wsUrl = `${protocol}://${host}/api/ws?token=${encodeURIComponent(token)}`;

    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      this.connected = true;
      this.startHeartbeat();
      this.emitLocal("socket_open", {
        type: "socket_open"
      });
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const type = data.type;

        if (type && this.handlers[type]) {
          this.handlers[type].forEach((cb) => cb(data));
        }

        if (this.handlers["*"]) {
          this.handlers["*"].forEach((cb) => cb(data));
        }
      } catch (err) {
        console.error("[LiveSocket] Parse error", err);
      }
    };

    this.socket.onclose = () => {
      this.connected = false;
      clearInterval(this.heartbeat);

      this.emitLocal("socket_close", {
        type: "socket_close"
      });

      this.reconnectTimer = setTimeout(() => {
        this.connect(token);
      }, 5000);
    };

    this.socket.onerror = (err) => {
      console.error("[LiveSocket] Error", err);
    };
  }

  startHeartbeat() {
    clearInterval(this.heartbeat);

    this.heartbeat = setInterval(() => {
      if (this.socket && this.connected) {
        this.send({ type: "ping" });
      }
    }, 30000);
  }

  emitLocal(eventType, data = {}) {
    if (
      eventType &&
      this.handlers[eventType]
    ) {
      this.handlers[eventType].forEach(
        (cb) => cb(data)
      );
    }
  }

  isConnected() {
    return Boolean(
      this.socket &&
      this.connected &&
      this.socket.readyState === WebSocket.OPEN
    );
  }

  send(data) {
    if (!this.socket || !this.connected) return;
    this.socket.send(JSON.stringify(data));
  }

  on(eventType, callback) {
    if (!this.handlers[eventType]) {
      this.handlers[eventType] = [];
    }

    this.handlers[eventType].push(callback);

    return () => {
      this.handlers[eventType] = this.handlers[eventType].filter(
        (cb) => cb !== callback
      );
    };
  }

  disconnect() {
    clearTimeout(this.reconnectTimer);
    clearInterval(this.heartbeat);

    if (this.socket) {
      this.socket.close();
    }

    this.socket = null;
    this.connected = false;
  }
}

const liveSocket = new LiveSocketClient();

export default liveSocket;
